module.exports = __webpack_public_path__ + "img/levels.959a9dff.svg";